import React from 'react'
import styled from 'styled-components'

import { groupTasksByCompletedStatus } from '../../common/utils'
import { GroupPayload } from './tasks-slice'

import TasksContainer from './TasksContainer'
import CompletedTasksActions from './CompletedTasksActions'

const Container = styled.div`
  position: relative;
`

type TaskItemListProps = {
  group: GroupPayload
}

const TaskItemList: React.FC<TaskItemListProps> = ({ group }) => {
  const { openTasks, completedTasks } = groupTasksByCompletedStatus(group.tasks)

  return (
    <Container data-testid="task-list">
      <TasksContainer
        testId="open-tasks-container"
        type="open"
        tasks={openTasks}
        groupName={group.name}
      />

      <TasksContainer
        testId="completed-tasks-container"
        type="completed"
        tasks={completedTasks}
        groupName={group.name}
      >
        {completedTasks.length > 0 && (
          <CompletedTasksActions groupName={group.name} />
        )}
      </TasksContainer>
    </Container>
  )
}

export default TaskItemList
